import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import app from 'flarum/forum/app';

export default class MessageComposer extends Component {
  view() {
    const a = this.attrs;
    const length = Array.from(a.draft).length;
    const t = key => app.translator.trans(`yingtao-forum-homepage.forum.private_messages.${key}`);
    return m('form.MessageComposer', { onsubmit: event => { event.preventDefault(); a.onSend(); } }, [
      m('textarea.FormControl', { 'aria-label': t('message_label'), value: a.draft, disabled: a.sending,
        oninput: event => a.onDraft(event.target.value), placeholder: t('message_placeholder') }),
      m('small', `${length}/2000`),
      Button.component({ type: 'submit', className: 'Button Button--primary', loading: a.sending,
        disabled: !a.draft.trim() || length > 2000 }, t('send')),
    ]);
  }
}
